export default {
    'abilityDetectnItemList': '/api/ability_detectn_item/list',    /**查询能力检测**/
    'addAbilityDetectnItem': '/api/ability_detectn_item/save',  /**新增能力检测 */
    'editAbilityDetectnItem': '/api/ability_detectn_item/edit',  /**新增能力检测 */
    'deleteAbilityDetectnItem': '/api/ability_detectn_item/del',  /**新增能力检测 */
}
